import { createSlice } from "@reduxjs/toolkit";

const diamondSizeSlice = createSlice({
    name:"diamondSize",
    initialState:{
        diamondSizes:null
    },
    reducers:{
        setDiamondSizeList(state,action){
            state.diamondSizes = action?.payload;
        },
    }
})


export const {setDiamondSizeList} = diamondSizeSlice.actions
export default diamondSizeSlice.reducer